import { validationMixin } from 'vuelidate'
import { required, maxLength, integer } from 'vuelidate/lib/validators' 
import { mapGetters, mapActions } from 'vuex'

export default {
  mixins: [validationMixin],
  validations: {
    phone: { required, maxLength: maxLength(17) },
    code: { required, maxLength: maxLength(12), integer  },
    // checkbox: {
    //   checked (val) {
    //     return val
    //   },
    // },
  },
  data: () => ({
    currentTime: 0,
    isLoad: false,
    isSenden: true,
    timer: null,
    phone: null,
    code: null,
    dialog: false,
    checkbox: false,
    isLoading: false
  }),

  methods: {
    ...mapActions(['setToken', 'setUser']),
    modal(){
      this.currentTime = 0;
      this.dialog = !this.dialog;
    },
    closse(){
      this.phone = null;
      this.code = null;
      this.dialog = false;
    },
    sendCode(){
      if(this.isLoad){
        return;
      }
      this.$v.phone.$touch();
      if(this.$v.phone.$invalid){
        return;
      }

      let phone = this.phone.replace(/[^\w\s]/gi, '');
      this.$axios.post('auth/code',{
        phone: phone
      }).then(res => {
        // store.commit('setUser', res.data.result.user)
      }).finally(() => {

      });
      
      this.isSenden = true;
      this.isLoad = true;
      this.currentTime = 60;
      this.startTimer();
    },
    startTimer() {
      this.timer = setInterval(() => {
        this.currentTime--
      }, 1000)
    },
    stopTimer() {
      clearTimeout(this.timer);
      this.isLoad = false;
    },
    submit () {
      this.$v.$touch();
      if(this.$v.$invalid){
        return;
      }
      this.isLoading = true;
      let phone = this.phone.replace(/[^\w\s]/gi, '');
      this.$axios.post('auth/login', {
        phone: phone,
        code: this.code,
      }).then(res => {
        if(res.data.result.access_token){
          this.setToken({token: res.data.result.access_token, isRemember: true});
          this.setUser(res.data.result.user);
          location.reload();
          // this.closse();
        }
      }).finally(() => {
        this.isLoading = false;
      });
    },

  },
  mounted() {
    this.$root.$on('modal.auth', (res) => {
      if(res){
        this.phone = res.phone;
      }
      this.modal();
    })
  },
  watch: {
    currentTime(time) {
      if (time === 0) {
        this.stopTimer()
      }
    }
  },
  computed: {
    phoneErrors () {
      const errors = []
      if (!this.$v.phone.$dirty) return errors
      !this.$v.phone.maxLength && errors.push('Неккоректный номер')
      !this.$v.phone.required && errors.push('Обязательное поле')
      return errors
    },
    codeErrors () {
      const errors = []
      if (!this.$v.code.$dirty) return errors
      !this.$v.code.integer && errors.push('Только числа')
      !this.$v.code.maxLength && errors.push('Неккоректный код')
      !this.$v.code.required && errors.push('Обязательное поле')
      return errors
    },
    checkboxErrors () {
      const errors = []
      if (!this.$v.checkbox.$dirty) return errors
      !this.$v.checkbox.checked && errors.push('Обязательное поле!')
      return errors
    },
  }
};


// WEBPACK FOOTER //
// ./src/modals/auth/auth.js